

module.exports = __webpack_require__.stylable.create(
    "BadgeIndicator4189916494",
    {"classes":{"root":"BadgeIndicator4189916494__root"},"vars":{"color-standard":"--BadgeIndicator4189916494-color-standard","color-alert":"--BadgeIndicator4189916494-color-alert","color-warning":"--BadgeIndicator4189916494-color-warning","color-success":"--BadgeIndicator4189916494-color-success"},"stVars":{},"keyframes":{}},
    "",
    2,
    "BadgeIndicator4189916494",
    null
);
